import { useState, useEffect } from "react";
import { Modal, Form, Input, Select, Button, Row, Col } from "antd";

const { Option } = Select;

const AddDriverModal = ({ open, onCancel, onSave, initialValues }) => {
  const [form] = Form.useForm();

  const [isDirty, setIsDirty] = useState(false);
  const [baseline, setBaseline] = useState(null);

  useEffect(() => {
    if (open) {
      const values = initialValues || {
        driver_name: "",
        contact_number: "",
        driver_type: "Employee",
      };
      form.setFieldsValue(values);
      setBaseline(values);
      setIsDirty(false);
    }
  }, [open, initialValues, form]);

  const handleValuesChange = (_, allValues) => {
    if (!initialValues) {
      setIsDirty(true);
      return;
    }
    
    let dirty = false;
    if (allValues.driver_name !== baseline?.driver_name) dirty = true;
    else if (allValues.contact_number !== baseline?.contact_number) dirty = true;
    else if (allValues.driver_type !== baseline?.driver_type) dirty = true;
    
    setIsDirty(dirty);
  };

  const sanitizeInput = (val) => {
    if (typeof val !== 'string') return val;
    return val.trim().replace(/\s+/g, ' ');
  };

  const handleSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        const sanitized = {
          ...values,
          driver_name: sanitizeInput(values.driver_name),
          contact_number: sanitizeInput(values.contact_number)
        };
        onSave(sanitized);
        form.resetFields();
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };

  return (
    <Modal
      open={open}
      title={initialValues ? "Edit Driver" : "Add New Driver"}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          Cancel
        </Button>,
        <Button 
          key="save" 
          type="primary" 
          className="ouber-btn-primary" 
          onClick={handleSubmit}
          style={{ marginBottom: 0 }}
          disabled={initialValues && !isDirty}
        >
          {initialValues ? "Save Changes" : "Add Driver"}
        </Button>
      ]}
      className="ouber-modal"
      width={600}
    >
      <Form 
        form={form} 
        layout="vertical" 
        name="driver_form"
        style={{ marginTop: '20px' }}
        onValuesChange={handleValuesChange}
      >
        <Form.Item
          name="driver_name"
          label="Driver Name"
          rules={[
            { required: true, message: "Please input the driver name!" },
          ]}
        >
          <Input placeholder="e.g. Juan Dela Cruz" />
        </Form.Item>

        <Form.Item
          name="contact_number"
          label="Contact Information"
          rules={[
            { required: true, message: "Please input the contact info!" },
            { pattern: /^09\d{9}$/, message: "Contact number must be 11 digits and start with 09" }
          ]}
        >
          <Input placeholder="e.g. 09123456789" maxLength={11} />
        </Form.Item>

        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              name="driver_type"
              label="Driver Type"
              rules={[{ required: true }]}
            >
              <Select>
                <Option value="Employee">Employee</Option>
                <Option value="Outsourced">Outsourced</Option>
                <Option value="Carpool">Carpool</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default AddDriverModal;
